import { FloatingFormItem } from '@/components/_common';
import ProfileSelect from '@/components/_common/ProfileSelect';
import { UserFormValues } from '@/core/domain/enterprise/Users/Users.types';
import { useDefaultEmptyFieldError } from '@/hooks';
import { Col, Form, FormInstance, Input, Row } from 'antd';
import UserExtraPassword from './UserExtraPassword';
import Authorities from '@/types/Authority';
import { hasPermissions } from '@/utils/functions/hasPermissions';
import EmployeesInfiniteSelectField from '@/components/_common/EmployeesInfiniteSelectField';

type Props = {
  form: FormInstance<UserFormValues>;
  isEdit?: boolean;
};

const UserForm: React.FC<Props> = ({ form, isEdit }) => {
  const ruleRequeired = useDefaultEmptyFieldError();
  const passwordField = Form.useWatch('password', form);

  return (
    <div>
      <Form form={form}>
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <FloatingFormItem
              name="login"
              label="Login"
              rules={[
                ruleRequeired,
                {
                  validator: (_, value) => {
                    if (value.length < 5 || value.length > 50) {
                      return Promise.reject(
                        ' Deve ter entre 5 e 50 caracteres',
                      );
                    }

                    if (/\s/.test(value)) {
                      return Promise.reject('Não pode conter espaços');
                    }

                    return Promise.resolve();
                  },
                },
              ]}
            >
              <Input />
            </FloatingFormItem>
          </Col>

          <Col span={24}>
            <FloatingFormItem
              name="email"
              label="E-mail"
              rules={[
                ruleRequeired,
                {
                  type: 'email',
                  message: 'Preencha este campo com um email válido',
                },
              ]}
            >
              <Input />
            </FloatingFormItem>
          </Col>

          <Col span={24}>
            <FloatingFormItem
              name="employeeId"
              label="Funcionário"
              rules={[ruleRequeired]}
            >
              <EmployeesInfiniteSelectField queryFilter={{ hasUser: false }} />
            </FloatingFormItem>
          </Col>

          {!isEdit && (
            <>
              <Col span={24}>
                <FloatingFormItem
                  name="password"
                  label="Senha"
                  rules={[
                    ruleRequeired,
                    {
                      pattern: /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9]).{8,}$/,
                      message: 'Senha inválida',
                    },
                  ]}
                  extra={
                    !!passwordField ? (
                      <UserExtraPassword password={passwordField} />
                    ) : undefined
                  }
                >
                  <Input.Password />
                </FloatingFormItem>
              </Col>

              <Col span={24}>
                <FloatingFormItem
                  name="passwordVerify"
                  label="Confimar senha"
                  dependencies={['password']}
                  hasFeedback
                  rules={[
                    ruleRequeired,
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (!value || getFieldValue('password') === value) {
                          return Promise.resolve();
                        }

                        return Promise.reject(new Error('Senha diferente!'));
                      },
                    }),
                  ]}
                >
                  <Input.Password />
                </FloatingFormItem>
              </Col>
            </>
          )}

          <Col span={24}>
            <FloatingFormItem
              label="Perfil"
              name="profileId"
              rules={[{ required: true }]}
              noStyle
              style={{ marginBottom: 0 }}
            >
              <ProfileSelect
                loading={false}
                disabled={
                  !hasPermissions([
                    Authorities.CONFIGURATION_MATRIX_ADD_USER_TO_GROUP,
                  ])
                }
              />
            </FloatingFormItem>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default UserForm;
